import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { MemCacheStorage as t } from "./MemCache.js";

var e = /*#__PURE__*/function () {
  function e(_e, s) {
    _classCallCheck(this, e);

    this._storage = new t(), this._storage.maxSize = _e, s && this._storage.registerRemoveFunc("", s);
  }

  _createClass(e, [{
    key: "put",
    value: function put(t, _e2, s) {
      this._storage.put(t, _e2, s, 1);
    }
  }, {
    key: "pop",
    value: function pop(t) {
      return this._storage.pop(t);
    }
  }, {
    key: "get",
    value: function get(t) {
      return this._storage.get(t);
    }
  }, {
    key: "clear",
    value: function clear() {
      this._storage.clearAll();
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._storage.destroy();
    }
  }, {
    key: "maxSize",
    get: function get() {
      return this._storage.maxSize;
    },
    set: function set(t) {
      this._storage.maxSize = t;
    }
  }]);

  return e;
}();

export { e as default };